import { constantsTypes } from "../reduxConstants";

export const addToCart = (value) => {
  return {
    type: constantsTypes.ADD_TO_CART,
    payload: value,
  };
};

export const removeFromCart = (value) => {
  return {
    type: constantsTypes.REMOVE_FROM_CART,
    payload: value,
  };
};
